import config from '../config';

export default (response): [] => {
    const { results } = response;
    results.forEach(item => {
        if (item.id === config.allCausesId) {
            item.level = 1;
        } else {
            item.level1_parent_id = config.allCausesId;
        }
    });
    return results;
};
